<select [class]="inputCssClass" [(ngModel)]="value" name="timeSelector">
  <option [ngValue]="">{{ blankLabel }}</option>
  <option *ngFor="let dateTime of timeValues" [ngValue]="dateTime | wlTimeTranslate">
    {{ dateTime | wlTimeTranslate }}
  </option>
</select>